module.exports = __webpack_public_path__ + "static/media/arrowLeft.920e1401.svg";